<template>
  <div class="aside__subblock">
    <div class="aside__list">
      <template v-if="step == 1">
        <div class="aside__item -full-">
          <Input
            v-model="group.name"
            title="Название"
            placeholder="Название группы"
            :error="$v.$dirty && !$v.group.name.required"
            @input="compare"
          >
            <span v-if="$v.$dirty && !$v.group.name.required" class="form-item__error">
              Обязательное поле
            </span>
          </Input>
        </div>
        <div class="aside__item -full-">
          <SelectFolder
            v-model="group.folderId"
            class="aside__select -folder-select-"
            title="Выберите родительскую папку"
            :fields="folders"
            @input="compare"
          ></SelectFolder>
        </div>
        <div class="aside__item -full-" @click="nextStep">
          <Button class="-xs-">Настройки доступа</Button>
        </div>
      </template>
      <Permissions
        v-if="step == 2"
        :prop-permissions="group.permissions"
        @updatePermissions="updatePermissions"
      ></Permissions>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SelectFolder from './SelectFolder';
import Permissions from '@/views/Users/Groups/layouts/Aside/components/Permissions';
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  components: { Permissions, SelectFolder },
  props: ['folders'],
  data: () => ({
    showPermissions: false,
    group: {
      permissions: {}
    },
    groupBackup: {}
  }),
  computed: {
    ...mapState('usersGroups', {
      storeGroup: s => s.aside.data.group,
      canSave: s => s.aside.meta.canSave,
      step: s => s.aside.meta.step
    })
  },
  beforeMount() {
    this.setData();
  },
  destroyed() {
    this.$store.dispatch('usersGroups/setAsideData', {
      path: 'group',
      value: {}
    });
    this.$store.dispatch('usersGroups/setAsideData', {
      path: 'stagedGroup',
      value: {}
    });
    this.$store.dispatch('usersGroups/setAsideMeta', {
      path: 'canSave',
      value: false
    });
  },
  methods: {
    setData() {
      this.group = _.cloneDeep(this.storeGroup);
      this.groupBackup = _.cloneDeep(this.group);
    },
    compare() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      const formHasChanges = !_.isEqual(this.group, this.groupBackup);
      if (this.canSave !== formHasChanges) {
        this.$store.dispatch('usersGroups/setAsideMeta', {
          path: 'canSave',
          value: formHasChanges
        });
      }

      if (this.canSave) {
        this.$store.dispatch('usersGroups/setAsideData', {
          path: 'stagedGroup',
          value: this.group
        });
      }
    },
    nextStep() {
      this.$store.dispatch('usersGroups/incrementStep');
    },
    updatePermissions(permissions) {
      this.group.permissions = { ...permissions };
      this.compare();
    }
  },
  validations: {
    group: {
      name: { required }
    }
  }
};
</script>
